import { Table, TableColumnsType } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { getCurrentSemester, getSemesters } from "../../../api/semesters.api";
import { getEnrolledStudentSummary } from "../../../api/statistics.api";
import useAxios from "../../../hooks/useAxios";
import { IGetCurrentSemester, IGetSemesters, ISemester } from "../../../models/semesters.model";
import { IEnrolledStudentParams } from "../../../models/statistics.model";
import { RootState } from "../../../store/rootReducer";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";
import Subtitle from "./Subtitle";

const Student = () => {
  const { t } = useTranslation();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { serverDate } = useSelector((state: RootState) => state.serverDate);  
  const { data: res, isLoading, error, execute } = useAxios<IGetCurrentSemester>();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetSemesters>();
  const { arr: res3, isLoading: isLoading3, error: error3, executeArr: execute3 } = useAxios<any>();

  const [data, setData] = useState<any>([]);

  useEffect(() => {
    execute(getCurrentSemester());
    execute2(getSemesters());
  }, []);

  useEffect(() => {
    if (res?.data?.semesterCode && !isLoading && res2 && !isLoading2 && currentCampus && serverDate) {
      const req: IEnrolledStudentParams = {
        semesterCode: res.data.semesterCode,
        campusCode: [currentCampus],
        date: moment(serverDate).subtract(1, 'days').format('YYYYMMDD'),
      }
      const prevReq: any = getPrevReq(res2?.data, req);  

      const arr: any = [getEnrolledStudentSummary(req)];
      if (prevReq) {
        arr.push(getEnrolledStudentSummary(prevReq));
      }
      execute3(arr);
    }
  }, [res, isLoading, res2, isLoading2, currentCampus]);

  useEffect(() => {
    if (res3 && !isLoading3) {
      const _data: any = [
        {
          title: t('class.dashboard.column5'),
          // @ts-ignore
          currentYear: res3.at(0)?.data?.at(0)?.s2Count,
          // @ts-ignore
          prevYear: res3.at(1)?.data?.at(0)?.s2Count,
          diffPercent: null,
        },
        {
          title: t('class.dashboard.column4'),
          // @ts-ignore
          currentYear: res3.at(0)?.data?.at(0)?.s1Count,
          // @ts-ignore
          prevYear: res3.at(1)?.data?.at(0)?.s1Count,
          diffPercent: null,
        },
      ];
      _data.push({
        title: t('class.dashboard.column20'),
        currentYear: _data[0].currentYear + _data[1].currentYear,
        prevYear: _data[0].prevYear + _data[1].prevYear,
        diffPercent: null,
      });

      if (_data[0].prevYear && _data[0].currentYear) {
        _data[0].diffPercent = Math.floor(((_data[0].currentYear - _data[0].prevYear) / _data[0].prevYear * 100) * 100) / 100;
      }
      if (_data[1].prevYear && _data[1].currentYear) {
        _data[1].diffPercent = Math.floor(((_data[1].currentYear - _data[1].prevYear) / _data[1].prevYear * 100) * 100) / 100;
      }
      if (_data[2].prevYear && _data[2].currentYear) {
        _data[2].diffPercent = Math.floor(((_data[2].currentYear - _data[2].prevYear) / _data[2].prevYear * 100) * 100) / 100;
      }

      setData(_data);
    }
  }, [res3, isLoading3]);
  
  const getPrevReq = (semesters: ISemester[], req: IEnrolledStudentParams) => {
    const currentSemester = semesters.find(item => item.semesterCode === req.semesterCode);
    const prevYear = String(Number(currentSemester?.learningYearCode) - 1);
    const prevSemester = semesters.find(item => item.learningYearCode === prevYear && item.semesterDiv === currentSemester?.semesterDiv);

    if (prevSemester) {
      return {
        ...req,
        date: moment(req.date).subtract(1, 'years').format('YYYYMMDD'),
        semesterCode: prevSemester.semesterCode,
      };
    }

    return null;
  }

  const columns: TableColumnsType<any> = [
    {
      title: '',
      dataIndex: 'title',
      key: 'title',
      align: 'center',
    },
    {
      title: moment().format('YYYY'),
      dataIndex: 'currentYear',
      key: 'currentYear',
      align: 'center',
      render: value => (value || value === 0) ? value : '-',
    },
    {
      title: moment().subtract(1, 'years').format('YYYY'),
      dataIndex: 'prevYear',
      key: 'prevYear',
      align: 'center',
      render: value => (value || value === 0) ? value : '-',
    },
    {
      title: t('class.dashboard.column21'),
      dataIndex: 'diffPercent',
      key: 'diffPercent',
      align: 'center',
      render: value => (value || value === 0) ? `${value}%` : '-',
    },
  ];

  return (
    <>
      {(isLoading || isLoading2 || isLoading3) && <Loader />}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <ErrorResponse error={error3} />

      <Subtitle
        text={t('class.dashboard.title9')}
        path="/statistics/student-enroll-month"
      />
      <Table
        className='comm-table__area'
        columns={columns}
        dataSource={data}
        rowClassName={(record: any) => record.title === t('class.dashboard.column20') ? 'chosen' : 'pointer'}
      />
    </>
  );
}

export default Student;
